<div class="app" *ngIf="showIframe">
  <div class="frame" >

    <iframe [src]="url" frameborder="0"></iframe>
  </div>
  <a href="https://app2.merytu.com/index.html" target="_blank"> <img class="logo" width="100" src="../assets/imgs/logo_merytu2025_branco.svg" alt="">
  </a>

</div>
